import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { ChartModel } from 'src/app/models/chart.model';
import { DealerCountry } from 'src/app/models/dealer-country.model';
import { Dealer } from 'src/app/models/dealer.model';
import { ChartsService } from 'src/app/services/charts.service';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { DealersService } from 'src/app/services/dealers.service';
import { UserService } from 'src/app/services/user.service';
import { TimeFrameForm } from '../../dto/timeFrameForm';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

class step {
  constructor(name: string, substeps: substep[], active: boolean, completed: boolean) {
    this.name = name;
    this.substeps = substeps;
    this.active = active;
    this.completed = completed;
  }

  name: string;
  substeps: substep[];
  active: boolean;
  completed: boolean;
}

class substep {
  constructor(name: string, active: boolean, completed: boolean) {
    this.name = name;
    this.active = active;
    this.completed = completed;
  }

  name: string;
  active: boolean;
  completed: boolean;
}

@Component({
  selector: 'app-admin-chart-pusher',
  templateUrl: './admin-chart-pusher.component.html',
  styleUrls: ['./admin-chart-pusher.component.scss']
})

export class AdminChartPusherComponent implements OnInit {

  currentStep = 0;
  currentSubstep = 0;
  steps: step[] = [];

  selectedDealers = new SelectionModel<any>(true, []);

  currentStepFinished = false;

  timeFrameForm = new TimeFrameForm('Daily', 1, new Date());

  currentOffset = 0;
  currentTake = 20;
  dealers: Dealer[];

  countries: DealerCountry[] = [];
  baseCountries: DealerCountry[] = [];
  countrySearchInput = '';
  countriesLoading = false;
  selectedCountries = new SelectionModel<any>(true, []);
  countryColumns: ColumnDefinition[] = [
    { columnDef: 'fullName', header: 'Name', cell: (w: any) => `${w.fullName}` }
  ];

  selectedCharts: any[] = [];
  finalCharts: ChartModel[] = [];
  chartToReview: ChartModel;

  duration: string = "";
  startTime: string;
  userType: string;

  constructor(private dealersService: DealersService, private chartsService: ChartsService, private router: Router, private route: ActivatedRoute, public dialog: MatDialog,
    private clickstream: ClickStreamService, private userService: UserService, private _snackBar: MatSnackBar) {

  }

  setupSteps() {

    const usersStepSubsets: substep[] = [new substep('Select your Countries', true, false)];
    const usersStep = new step('Users', usersStepSubsets, true, false);

    const chartsStepSubsets: substep[] = [new substep('Select Charts', false, false)];
    const chartsStep: step = new step('Chart', chartsStepSubsets, false, false);

    const timeFrameStep: step = new step('Time Frame', [], false, false);

    const reviewStep: step = new step('Review & Push', [], false, false);

    this.currentStep = 0;
    this.steps = [usersStep, chartsStep, timeFrameStep, reviewStep];
  }

  ngOnInit() {

    this.userType = this.userService.user.businessFunction;
    this.setupSteps();

    if (this.route.snapshot.paramMap.get('chartGuid') && this.route.snapshot.paramMap.get('timeFrameId')) {
      var chartGuid = this.route.snapshot.paramMap.get('chartGuid');
      var timeFrameId = this.route.snapshot.paramMap.get('timeFrameId');
      this.countriesLoading = true;
      this.chartsService.getGroupsForChart(chartGuid, timeFrameId).subscribe((groups: any[]) => {
        this.dealersService.getDealerCountries().subscribe(countries => {
          for (let c of countries) {
            let selected = false;
            for (let g of groups) {
              if (c.country == g.country.country) {
                this.selectedCountries.select(g.country);
                this.countries.push(g.country);
                selected = true;
              }
            }
            if (!selected) this.countries.push(c);
          }
          this.baseCountries = this.countries;
          this.countriesLoading = false;
        });
        this.selectedCharts = [groups[0].insight.state];
        this.timeFrameForm = groups[0].timeFrame;
        this.timeFrameForm.valid = true;
        this.addTimeFrameSubstep(false);
        this.finalCharts = this.selectedCharts;
        this.finalCharts[0].timeFrame = this.timeFrameForm;
        this.setupReviewStep();
        for (let step of this.steps) {
          if (step.substeps) step.substeps.map(ss => ss.completed = true);
          step.completed = true;
        }
      })
    } else {
      if (this.userType === 'dealeradmin') {
        this.dealersService.getDealerCountries().subscribe(countries => {
          this.countries = countries;
          this.baseCountries = countries;
        })
      }
    }
  }

  next() {
    // current step does not have any children
    if (this.currentSubstep == -1) {
      this.steps[this.currentStep].active = false;
      this.steps[this.currentStep].completed = true;

      this.currentStep++;
      this.steps[this.currentStep].active = true;
      if (this.steps[this.currentStep].substeps.length > 0) this.currentSubstep++;
      // current step has children, thus we are on a substep
    } else {
      this.steps[this.currentStep].substeps[this.currentSubstep].active = false;
      this.steps[this.currentStep].substeps[this.currentSubstep].completed = true;

      if (this.steps[this.currentStep].substeps.length - 1 > this.currentSubstep) {
        this.currentSubstep++;
        this.steps[this.currentStep].substeps[this.currentSubstep].active = true;
        this.steps[this.currentStep].substeps[this.currentSubstep].completed = true;
      } else {
        this.steps[this.currentStep].completed = true;
        this.steps[this.currentStep].active = false;
        this.currentStep++;
        this.steps[this.currentStep].active = true;
        if (this.steps[this.currentStep].substeps.length > 0) {
          this.currentSubstep = 0;
          this.steps[this.currentStep].substeps[this.currentSubstep].active = true;
          this.steps[this.currentStep].substeps[this.currentSubstep].completed = true;
        } else {
          this.currentSubstep = -1;
        }
      }
    }
  }

  back() {
    // current  step has no children
    if (this.currentSubstep == -1) {
      this.currentStep--;
      this.steps[this.currentStep].active = true;
      if (this.steps[this.currentStep].substeps.length > 0) {
        this.currentSubstep = this.steps[this.currentStep].substeps.length - 1;
        this.steps[this.currentStep].substeps[this.currentSubstep].active = true;
      } else {
        this.currentSubstep = -1;
      }
      // current step has children, thus we are on a substep
    } else {
      // set current substep to not active or completed before going back
      this.steps[this.currentStep].substeps[this.currentSubstep].active = false;
      this.currentSubstep--;
      // if you're still on a substep, activate it
      if (this.currentSubstep >= 0) {
        this.steps[this.currentStep].substeps[this.currentSubstep].active = true;
      } else {
        // if currentSubstep is negative, you are on a new step
        this.currentStep--;
        // check if the new step has substeps, if so go to the last one
        if (this.steps[this.currentStep].substeps != []) {
          this.currentSubstep = this.steps[this.currentStep].substeps.length - 1;
          this.steps[this.currentStep].substeps[this.currentSubstep].active = true;
        }
      }
    }
  }

  clickStep(stepIndex: number) {
    // first need to de-activate the current substep if on one
    if (this.steps[stepIndex].active || this.steps[stepIndex].completed) {
      if (this.currentSubstep >= 0) this.steps[this.currentStep].substeps[this.currentSubstep].active = false;
      this.steps[stepIndex].active = true;
      this.currentStep = stepIndex;
      if (this.steps[stepIndex].substeps.length > 0) {
        this.steps[stepIndex].substeps[0].active = true;
        this.currentSubstep = 0;
      } else {
        this.currentSubstep = -1;
      }
    }
    this.clickstream.send('click-step', 'click', 'Push ChartModel - Choose Your Users', this.steps[stepIndex].name + ' Wizard Step')
  }

  clickSubstep(stepIndex: number, substepIndex: number) {
    if (this.steps[stepIndex].substeps[substepIndex].active || this.steps[stepIndex].substeps[substepIndex].completed) {
      if (this.currentSubstep >= 0) this.steps[this.currentStep].substeps[this.currentSubstep].active = false;
      this.steps[stepIndex].active = true;
      this.steps[stepIndex].substeps[substepIndex].active = true;
      this.currentStep = stepIndex;
      this.currentSubstep = substepIndex;
    }
  }

  addTimeFrameSubstep(goNext: boolean) {
    let timeFrameIndex = 2;
    if (this.steps[timeFrameIndex].substeps.length > 0) {
      this.steps[timeFrameIndex].substeps = this.steps[timeFrameIndex].substeps.filter(ss => this.selectedCharts.some(sc => sc.name == ss.name)); // filter out all substeps that got removed
      this.finalCharts = this.finalCharts.filter(fc => this.selectedCharts.some(sc => fc.name == sc.name)); // filter out all charts that got removed
    }
    for (let c of this.selectedCharts) {
      if (!this.finalCharts.some(fc => fc.name == c.name)) { // if its not in the finals, gotta make a new substep and add it to finals
        var newSs: substep = new substep(c.name, false, false);
        this.steps[timeFrameIndex].substeps.push(newSs);
        var newChart: ChartModel = new ChartModel();
        newChart.name = c.name;
        newChart.chartDataGuid = c.guid;
        newChart.timeFrame = (this.timeFrameForm) ? this.timeFrameForm : new TimeFrameForm('Daily', 1, new Date());
        this.finalCharts.push(newChart);
      }
    }

    if (goNext) this.next();
  }

  setupReviewStep() {
    this.chartToReview = this.finalCharts[0];
    this.timeFrameForm = this.chartToReview.timeFrame;
    this.setTimeFrame();
  }

  setTimeFrame() {
    this.duration = this.chartsService.formatTimeFrame(this.timeFrameForm);
  }

  clickReviewChart(chart: ChartModel) {
    this.chartToReview = chart;
    this.timeFrameForm = this.chartToReview.timeFrame;
    this.setTimeFrame();
    this.clickstream.send('click-chart-to-review', 'click', 'Push ChartModel - Review and Push', 'ChartModel', '', true);
  }

  pushCharts() {
    let externalIds = [];
    if (this.userType === 'dealeradmin') {
      externalIds = this.selectedCountries.selected.map(c => c.country);
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { charts: this.finalCharts, externalIds: externalIds }, panelClass: 'confirm-dialog' });
    this.clickstream.send('click-push-charts-button', 'click', 'Push ChartModel - Review and Push', 'Save and Push Button', '', true);
  }

  searchCountries(query: string) {
    const filterBy = query.toLowerCase();
    this.countries = this.baseCountries.filter(e => e.fullName.toLowerCase().indexOf(filterBy) != -1);
  }
}
